import React from "react";
import ListBody from "./ListBody";
import DeleteResourceButton from "./DeleteResourceButton";
import { FormattedMessage } from "react-intl";
import NotSetValue from "./NotSetValue";
import { Table, TableCell, TableHead, TableRow } from "@mui/material";

type UserAliasesTableProps = {
    rows: any[];
    showOwnerType?: boolean;
    showDeleteButton?: boolean;
};

const UserAliasesTable: React.FC<UserAliasesTableProps> = ({
    rows,
    showOwnerType = false,
    showDeleteButton = true,
}) => {
    if (rows.length == 0) return <NotSetValue label="user_alias.empty" />;

    return (
        <Table>
            {showOwnerType && (
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <FormattedMessage id="user_alias.name" />
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="user_alias.owner_type" />
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
            )}
            <ListBody
                data={rows}
                header={["name"].concat(showOwnerType ? ["owner_type"] : []).concat("controlHeader")}
                renderers={{
                    owner_type: (val, row) => {
                        // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
                        return <FormattedMessage id={`user_alias.${val}`} />;
                    },
                    controlHeader: (val, row) => {
                        if (!showDeleteButton) return null;
                        return <DeleteResourceButton resourceName="user_alias" id={row.id} />;
                    },
                }}
            />
        </Table>
    );
};

export default UserAliasesTable;
